const initHeader = () => {
  const header = document.querySelector('[data-header]')
  const menu = document.querySelector('[data-menu]')
  const menuToggles = document.querySelectorAll('[data-menu-toggle]')
  const languageSwitcher = document.querySelector('#language')
  const focusableContent = menu.querySelectorAll('button, a')
  const firstFocusableElement = focusableContent[0]
  const lastFocusableElement = focusableContent[focusableContent.length - 1]

  const loopTabFocus = (e) => {
    let isTabPressed = e.key === 'Tab' || e.keyCode === 9

    if (!isTabPressed) {
      return
    }

    if (e.shiftKey) {
      if (document.activeElement === firstFocusableElement) {
        lastFocusableElement.focus()
        e.preventDefault()
      }
    } else {
      if (document.activeElement === lastFocusableElement) {
        firstFocusableElement.focus()
        e.preventDefault()
      }
    }
  }

  const setActiveClass = (element, hideContent) => {
    element.classList.toggle('active')
    hideContent && document.body.classList.toggle('menu-active')
  }
  const setHeaderClass = (e) => {
    if (window.scrollY === 0 && header.classList.contains('active')) {
      setActiveClass(header)
    }

    if (window.scrollY > 0 && !header.classList.contains('active')) {
      setActiveClass(header)
    }
  }

  const observer = new MutationObserver(([mutation]) => {
    if (mutation.target.classList.contains('active')) {
      document.addEventListener('keydown', loopTabFocus)
    } else {
      document.removeEventListener('keydown', loopTabFocus)
    }
  })

  languageSwitcher?.addEventListener('change', (e) => {
    window.location.assign(e.target.value)
  })

  window.addEventListener('scroll', setHeaderClass)
  menuToggles.forEach((toggle) => toggle.addEventListener('click', () => setActiveClass(menu, true)))

  observer.observe(menu, { attributeFilter: ['class'] })
}

export default initHeader
